"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "MachineFailure";

export default {
  getAllMachineFailures() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllMachineFailures`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getMachinesFailureByVehicleID(vehicleId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/GetMachinesFailureByVehicleID`,
        `?vehicleID=${vehicleId}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  },
  save(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/Save`, payload).result.then(({ data }) => {
        resolve(data);
      });
    });
  }
};
